import styled from 'styled-components';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from 'components/accordion';
import { Button, Label } from 'components';
import { MASKED_TEXT_CLASS } from 'analytics/constants';
import { TestToneButton } from './TestToneButton';

export const DeviceSettingsAccordion = styled(Accordion).attrs({
  className: 'rounded-md border border-border px-3 shadow-xs',
})``;

export const DeviceSettingsItem = styled(AccordionItem).attrs({
  className: 'border-b-0',
})``;

export const DeviceSettingsTrigger = styled(AccordionTrigger).attrs<{ $open: boolean }>(
  ({ $open }) => ({
    variant: 'arrow',
    className: `cursor-pointer py-3 text-sm font-medium hover:no-underline ${$open ? '' : 'text-muted-foreground'}`,
  })
)<{ $open: boolean }>``;

export const DeviceSettingsContent = styled(AccordionContent).attrs({
  className: 'space-y-3 rounded-md bg-vantis-silver px-3 pt-2 pb-3',
})``;

export const DeviceSettingsRows = styled.div.attrs({
  className: 'grid grid-cols-[minmax(0,15.25rem)_auto] items-center gap-x-6 gap-y-1',
})``;

export const FieldLabel = styled(Label).attrs({
  className: 'col-span-2 text-xs font-semibold',
})``;

export const SpeakerFieldLabel = styled(FieldLabel).attrs({
  className: 'mt-2',
})``;

export const DeviceSelect = styled.select.attrs<{ $empty: boolean }>(({ $empty }) => ({
  className: `h-8 w-full min-w-0 truncate rounded-lg border border-input bg-white px-2.5 text-sm outline-none focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 ${$empty ? 'text-muted-foreground' : ''}`,
}))<{ $empty: boolean }>``;

export const DeviceOption = styled.option.attrs({
  className: MASKED_TEXT_CLASS,
})``;

export const SettingsTestToneButton = styled(TestToneButton).attrs({
  className: 'h-8 justify-self-start px-2.5 text-sm',
})``;

export const NotifyRow = styled.div.attrs({
  className: 'flex items-center gap-3',
})``;

export const NotifyLabel = styled(Label).attrs({
  className: 'text-xs font-normal',
})``;

export const SaveButton = styled(Button).attrs({
  className: 'h-7 rounded-lg px-2.5 text-xs font-medium',
})``;
